import addStartupScript from 'mex_components/app/scripts/events/addStartupScript';
import initializeAnalytics from './analytics/initialize_analytics';

addStartupScript(initializeAnalytics);
